function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 250) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantInit()
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantInit() {
    this.updateOptions();
    // this.updateHiddenProperties();
  }

  onVariantChange() {
    this.updateOptions();
    // this.updateHiddenProperties();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }


  formatMoney(cents) {
    const amount = Number(cents) || 0;
    const shopCurrency = window.shop_currency || 'EUR';
    const formats = window.Currency && Currency.moneyFormats && Currency.moneyFormats[shopCurrency];
    const format =
      (formats && formats.money_with_currency_format) ||
      (formats && formats.money_format) ||
      window.money_format ||
      '${{amount}}';

    if (window.Currency && typeof Currency.formatMoney === 'function') {
      return Currency.formatMoney(amount, format);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, format);
    }
    return `€${(amount / 100).toFixed(2)}`;
  }

  setMoneyElement(el, cents) {
    if (!el) return;
    const formatted = this.formatMoney(cents);
    const money = el.matches?.('span.money') ? el : el.querySelector?.('span.money');
    if (money) {
      money.textContent = formatted;
      // Reset conversion cache so currency() rebuilds for active market
      [...money.attributes]
        .map((attr) => attr.name)
        .filter((name) => name.startsWith('data-currency'))
        .forEach((name) => money.removeAttribute(name));
    } else {
      el.innerHTML = `<span class="money">${formatted}</span>`;
    }
  }

  updatePriceFromVariant() {
    const priceRoot = document.getElementById(`price-${this.dataset.section}`);
    if (!priceRoot || !this.currentVariant) return;

    const variant = this.currentVariant;
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const onSale = compareAt && compareAt > price;
    const priceEl = priceRoot.querySelector('.price') || priceRoot;

    priceEl.classList.toggle('price--on-sale', Boolean(onSale));
    priceEl.classList.toggle('price--sold-out', variant.available === false);
    priceRoot.classList.remove('visibility-hidden');

    const saleRegular = priceEl.querySelector('.price__sale .price-item--regular');
    const salePrice = priceEl.querySelector('.price__sale .price-item--sale');
    const regularPrice = priceEl.querySelector('.price__regular .price-item--regular');

    if (onSale) {
      if (saleRegular) this.setMoneyElement(saleRegular, compareAt);
      if (salePrice) this.setMoneyElement(salePrice, price);
      if (regularPrice) this.setMoneyElement(regularPrice, price);
    } else if (regularPrice) {
      this.setMoneyElement(regularPrice, price);
    } else if (salePrice) {
      this.setMoneyElement(salePrice, price);
    }

    const saleBadge = priceEl.querySelector('.price__badge-sale');
    if (saleBadge) {
      saleBadge.style.display = onSale ? '' : 'none';
    }

    const soldOutBadge = priceEl.querySelector('.price__badge-sold-out');
    if (soldOutBadge) {
      soldOutBadge.style.display = variant.available === false ? '' : 'none';
    }

    if (typeof window.dunterySyncStickyAtc === 'function') {
      window.dunterySyncStickyAtc();
    }
  }

  updateAfterpayFromVariant() {
    if (!this.currentVariant) return;
    const amount = (Number(this.currentVariant.price) / 100).toFixed(2);
    if (typeof window.updateAfterpayAmount === 'function') {
      window.updateAfterpayAmount(amount, window.shop_currency);
      return;
    }
    if (typeof window.initializeAfterpay === 'function') {
      const widget = document.getElementById('afterpay-messaging-widget');
      if (widget) widget.setAttribute('data-amount', amount);
      window.initializeAfterpay(true);
    }
  }

  renderProductInfo() {
    this.updatePriceFromVariant();
    this.currency();
    this.updateAfterpayFromVariant();
    const soldOut =
      (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    this.toggleAddButton(!this.currentVariant.available, soldOut);
  }

  currency() {
    const cur = document.querySelector('#currencies .active');
    if (!cur || typeof window.Currency?.convertAll !== 'function') return;
    const currency = cur.getAttribute('data-currency');
    if (!currency) return;
    Currency.convertAll(window.shop_currency, currency, 'span.money', 'money_format');
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && addButtonText) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) {
        addButtonText.textContent =
          addButtonText.dataset.labelAdd ||
          (window.variantStrings && window.variantStrings.addToCart) ||
          'ADD TO BAG';
      }
    }

    if (!modifyClass) return;

    if (typeof window.dunterySyncStickyAtc === 'function') {
      window.dunterySyncStickyAtc();
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateHiddenProperties() {
      const sizeMap = {
          "EU32": "US0(Bust:32inch / 81cm, Waist:25½inch / 65cm, Hips:35½inch / 90cm, Hollow to Hem:",
          "EU34": "US2(Bust:33inch / 84cm, Waist:26½inch / 67cm, Hips:36½inch / 93cm, Hollow to Hem:",
          "EU36": "US4(Bust:34inch / 86cm, Waist:27½inch / 70cm, Hips:37½inch / 95cm, Hollow to Hem:",
          "EU38": "US6(Bust:35inch / 89cm, Waist:28½inch / 72cm, Hips:38½inch / 98cm, Hollow to Hem:",
          "EU40": "US8(Bust:36inch / 91cm, Waist:29½inch / 75cm, Hips:39½inch / 100cm, Hollow to Hem:",
          "EU42": "US10(Bust:37½inch / 95cm, Waist:31inch / 79cm, Hips:41inch / 104cm, Hollow to Hem:",
          "EU44": "US12(Bust:39inch / 99cm, Waist:32½inch / 83cm, Hips:42½inch / 108cm, Hollow to Hem:",
          "EU46": "US14(Bust:41¼inch / 104cm, Waist:34¼inch / 88cm, Hips:44½inch / 113cm, Hollow to Hem:",
          "EU48": "US16(Bust:43¼inch / 110cm, Waist:37¼inch / 95cm, Hips:46¾inch / 119cm, Hollow to Hem:",
          "EU50": "US18(Bust:45½inch / 116cm, Waist:39¾inch / 101cm, Hips:49inch / 124cm, Hollow to Hem:",
          "EU52": "US20(Bust:47¾inch / 121cm, Waist:42¼inch / 107cm, Hips:51¼inch / 130cm, Hollow to Hem:",
          "EU54": "US22(Bust:50inch / 127cm, Waist:44¾inch / 114cm, Hips:53½inch / 136cm, Hollow to Hem:",
          "EU56": "US24(Bust:53inch / 135cm, Waist:48inch / 122cm, Hips:56½inch / 144cm, Hollow to Hem:",
          "EU58": "US26(Bust:56inch / 142cm, Waist:51¼inch / 130cm, Hips:59½inch / 151cm, Hollow to Hem:",
          "EU60": "US28(Bust:59inch / 150cm, Waist:54½inch / 138cm, Hips:62½inch / 159cm, Hollow to Hem:",
          "EU62": "US30(Bust:63inch / 160cm, Waist:58¾inch / 149cm, Hips:66½inch / 169cm, Hollow to Hem:",
          "J4": "J4(Bust:22inch / 56cm, Waist:20inch / 51cm, Hips:25inch / 64cm, Hollow to Hem:",
          "J6": "J6(Bust:24inch / 61cm, Waist:22inch / 56cm, Hips:27inch / 69cm, Hollow to Hem:",
          "J8": "J8(Bust:26inch / 66cm, Waist:24inch / 61cm, Hips:29inch / 74cm, Hollow to Hem:",
          "J10": "J10(Bust:28inch / 71cm, Waist:26inch / 66cm, Hips:31inch / 79cm, Hollow to Hem:",
          "J12": "J12(Bust:30inch / 76cm, Waist:28inch / 71cm, Hips:33inch / 84cm, Hollow to Hem:",
          "J14": "J14(Bust:32inch / 81cm, Waist:30inch / 76cm, Hips:35inch / 89cm, Hollow to Hem:",
          "J16": "J16(Bust:34inch / 86cm, Waist:32inch / 81cm, Hips:37inch / 94cm, Hollow to Hem:",
          "2": "2(Bust:20¾inch / 53cm, Waist:20inch / 51cm, Hips:20inch / 51cm, Shoulder To Floor:",
          "3": "3(Bust:22inch / 56cm, Waist:20¾inch / 53cm, Hips:20¾inch / 53cm, Shoulder To Floor:",
          "4": "4(Bust:22¾inch / 58cm, Waist:22inch / 56cm, Hips:22inch / 56cm, Shoulder To Floor:",
          "5": "5(Bust:24inch / 61cm, Waist:22¾inch / 58cm, Hips:22¾inch / 58cm, Shoulder To Floor:",
          "6": "6(Bust:25¼inch / 64cm, Waist:24inch / 61cm, Hips:25¼inch / 64cm, Shoulder To Floor:",
          "7": "7(Bust:26inch / 66cm, Waist:25¼inch / 64cm, Hips:26inch / 66cm, Shoulder To Floor:",
          "8": "8(Bust:27¼inch / 69cm, Waist:26inch / 66cm, Hips:27¼inch / 69cm, Shoulder To Floor:",
          "9": "9(Bust:28inch / 71cm, Waist:27¼inch / 69cm, Hips:29¼inch / 74cm, Shoulder To Floor:",
          "10": "10(Bust:29¼inch / 74cm, Waist:28inch / 71cm, Hips:31inch / 79cm, Shoulder To Floor:",
          "11": "11(Bust:30¼inch / 77cm, Waist:29¼inch / 74cm, Hips:33inch / 84cm, Shoulder To Floor:",
          "12": "12(Bust:32inch / 81cm, Waist:30inch / 76cm, Hips:33¾inch / 86cm, Shoulder To Floor:",
          "13": "13(Bust:33inch / 84cm, Waist:31inch / 79cm, Hips:34¾inch / 88cm, Shoulder To Floor:",
          "14": "14(Bust:33¾inch / 86cm, Waist:32inch / 81cm, Hips:35inch / 89cm, Shoulder To Floor:"
      };

      const checkedSizeInput = document.querySelector('input[name="properties\\[Taille\\]"]:checked');
      const hiddenSizeInput = document.querySelector('input[name="properties\\[_Size_US\\]"]');

      if (checkedSizeInput && hiddenSizeInput) {
        hiddenSizeInput.value = "";
        const spanElement = checkedSizeInput.nextElementSibling;
        const lengthValue = checkedSizeInput.getAttribute('data-length');
        
        if (spanElement && spanElement.tagName === 'SPAN') {
            const ukSizeText = spanElement.innerText.trim(); 
            const usSize = sizeMap[ukSizeText] || ukSizeText;
            hiddenSizeInput.value = usSize + lengthValue + ")"; 
        }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.announcement-bar-list');
    this.listitems = Array.from(this.querySelectorAll('.announcement-bar-item'));
    this.buttons = Array.from(this.querySelectorAll('button[type="button"]'));
    this.circles = Array.from(this.querySelectorAll('circle[role="button"]'));

    if (!this.listitems.length || !this.buttons.length || !this.circles.length) return;
    this.list.addEventListener('scroll', this.setItemVisibility.bind(this));
    this.setItemVisibility();
    this.buttons.forEach(button => button.addEventListener('click', (evt) => this.btnAction(evt)));
    this.circles.forEach(circle => circle.addEventListener('click', (evt) => this.focusto(evt)));

    if (this.autoPlay) this.setAutoPlay();
  }

  get autoPlay() {
    return this.hasAttribute('data-autoplay');
  }

  get current() {
    return this.listitems.length - Math.round((this.list.scrollWidth - this.list.scrollLeft) / this.list.offsetWidth);
  }

  setAutoPlay() {
    this.timer = setInterval(this.next.bind(this), this.dataset.speed * 1000);
  }

  btnAction(e) {
    if (this.autoPlay) clearInterval(this.timer);
    if (e.currentTarget.dataset.action == 'prev') {
      this.nextIndex = this.current == 0 ? this.listitems.length - 1 : this.current - 1;
      this.move();
    } else {
      this.next();
    }
    if (this.autoPlay) this.setAutoPlay();
  }

  next() {
    this.nextIndex = this.current == this.listitems.length - 1 ? 0 : this.current + 1;
    this.move();
  }

  focusto(e) {
    if (this.autoPlay) clearInterval(this.timer);
    this.nextIndex = this.circles.findIndex(circle => circle == e.currentTarget);
    this.move();
    if (this.autoPlay) this.setAutoPlay();
  }

  move() {
    this.list.scrollTo({
      left: this.nextIndex * this.list.offsetWidth
    });
  }

  setItemVisibility() {
    this.listitems.forEach((item, index) => {
      if (index == this.current) {
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
        this.circles[index].setAttribute('fill-opacity', '1');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        this.circles[index].setAttribute('fill-opacity', '0.6');
      }
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);


$(document).ready(() => {
  if ($(window).width() < 749) {
    $('.product__accordion details').removeAttr('open');
  }
});

$(window).resize(() => {
  if ($(window).width() < 749) {
    $('.product__accordion details').removeAttr('open');
  }
});



(() => {
  setTimeout(() => {
    const videoIframes = document.querySelectorAll('.product .product__accordion iframe');
    videoIframes.forEach((iframe) => {
      iframe.setAttribute('src', iframe.dataset.src);
    });
  }, 500);
})();